import { styled } from 'styled-components';

const StyledCategoryList = styled.ul`
  padding: 0;
`;

export { StyledCategoryList };
